// extracted by mini-css-extract-plugin
export var description = "style-module--description--1236a";
export var loqate = "style-module--loqate--009ea";
export var resultsClass = "style-module--resultsClass--319dd";
export var spinner = "style-module--spinner--3fa2e";